<template>
  <v-container>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout>
        <jti-expansion-panel panelName="Company Details">
          <v-container grid-list-lg class="my-0 py-0">
            <v-layout wrap>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.name"
                  label="Name"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.code"
                  label="Code"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.slogan"
                  label="Slogan"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.email"
                  label="E-mail"
                  :readonly="readonly"
                  required
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.website"
                  label="Website"
                  :readonly="readonly"
                  hint="www.test.com"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.min"
                  label="MIN"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.tin"
                  label="TIN"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field
                  v-model="data.accreditation"
                  label="Accreditation"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field v-model="data.block" label="Block" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field v-model="data.lot" label="Lot" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field v-model="data.street" label="Street" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field v-model="data.barangay" label="Barangay" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex lg4 class="py-0">
                <v-text-field v-model="data.city" label="City" :readonly="readonly"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </jti-expansion-panel>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    readonly: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        code: this.data.code,
        slogan: this.data.slogan,
        email: this.data.email,
        website: this.data.website,
        min: this.data.min,
        tin: this.data.tin,
        accreditation: this.data.accreditation,
        block: this.data.block,
        lot: this.data.lot,
        street: this.data.street,
        barangay: this.data.barangay,
        city: this.data.city
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    }
  }
};
</script>

<style>
</style>
